"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var effects_1 = require("redux-saga/effects");
var moveInService_1 = require("../services/moveInService");
var settingsSelectors_1 = require("../selectors/settingsSelectors");
var moveInSelector_1 = require("../selectors/moveInSelector");
var i18n_1 = __importDefault(require("../i18n"));
var reportErrorsToInstrumentation_1 = __importStar(require("../helper/reportErrorsToInstrumentation"));
var moveInState_1 = require("../states/moveInState");
function onlyUniqueByFullLabel(element, index, self) {
    return self.map(function (el) { return el === null || el === void 0 ? void 0 : el.fullLabel; }).indexOf(element === null || element === void 0 ? void 0 : element.fullLabel) === index;
}
function handleSuggestions(data) {
    var suggestions = data;
    //on format la liste pour le composant et on enléve les doublons
    return suggestions.map(function (address) {
        return {
            id: address.id.toString(),
            fullLabel: "".concat(address === null || address === void 0 ? void 0 : address.zipCode, " - ").concat(address === null || address === void 0 ? void 0 : address.name),
            value: address,
            label: "".concat(address === null || address === void 0 ? void 0 : address.zipCode, " - ").concat(address === null || address === void 0 ? void 0 : address.name),
        };
    }).filter(onlyUniqueByFullLabel);
}
function handleCities(data) {
    var cities = data;
    return cities.map(function (city) {
        return {
            id: city.idLocalite.toString(),
            value: city.localite,
            label: "".concat(city.codePostal, " - ").concat(city.localite),
        };
    });
}
function getCommuneSuggestionEffect(action) {
    var data, e_1, language, errorMsg, errorCode;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 6, , 9]);
                return [4 /*yield*/, (0, effects_1.call)(moveInService_1.getCommuneSuggestion, action.payload)];
            case 1:
                data = _b.sent();
                if (!data.length) return [3 /*break*/, 3];
                return [4 /*yield*/, (0, effects_1.put)(moveInState_1.moveInActions.getCommuneSuggestionSuccess(handleSuggestions(data)))];
            case 2:
                _b.sent();
                return [3 /*break*/, 5];
            case 3: return [4 /*yield*/, (0, effects_1.put)(moveInState_1.moveInActions.getCommuneSuggestionSuccess([]))];
            case 4:
                _b.sent();
                _b.label = 5;
            case 5: return [3 /*break*/, 9];
            case 6:
                e_1 = _b.sent();
                return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 7:
                language = (_b.sent()).language;
                errorMsg = (0, i18n_1.default)(language).api.auth.errors.unknownError;
                errorCode = (_a = e_1 === null || e_1 === void 0 ? void 0 : e_1.response) === null || _a === void 0 ? void 0 : _a.status;
                return [4 /*yield*/, (0, effects_1.put)(moveInState_1.moveInActions.getCommuneSuggestionFailure(errorMsg, errorCode))];
            case 8:
                _b.sent();
                return [3 /*break*/, 9];
            case 9: return [2 /*return*/];
        }
    });
}
function subscribeEffect(action) {
    var form, e_2, language, errorMsg, errorCode;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 4, , 8]);
                return [4 /*yield*/, (0, effects_1.select)(moveInSelector_1.getSubscriptionForm)];
            case 1:
                form = _b.sent();
                return [4 /*yield*/, (0, effects_1.call)(moveInService_1.subscribe, form)];
            case 2:
                _b.sent();
                return [4 /*yield*/, (0, effects_1.put)(moveInState_1.moveInActions.subscribeSuccess())];
            case 3:
                _b.sent();
                return [3 /*break*/, 8];
            case 4:
                e_2 = _b.sent();
                return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 5:
                language = (_b.sent()).language;
                errorMsg = (0, i18n_1.default)(language).api.auth.errors.unknownError;
                errorCode = (_a = e_2 === null || e_2 === void 0 ? void 0 : e_2.response) === null || _a === void 0 ? void 0 : _a.status;
                return [4 /*yield*/, (0, effects_1.put)(moveInState_1.moveInActions.subscribeFailure(errorMsg, errorCode))];
            case 6:
                _b.sent();
                return [4 /*yield*/, (0, effects_1.call)(reportErrorsToInstrumentation_1.default, e_2, reportErrorsToInstrumentation_1.ErrorSourceType.DATA_INTEGRITY_ERROR, (0, reportErrorsToInstrumentation_1.getCorrelationId)(0, subscribeEffect.name))];
            case 7:
                _b.sent();
                return [3 /*break*/, 8];
            case 8: return [2 /*return*/];
        }
    });
}
function communeEligibilityEffect(action) {
    var response, e_3, language, errorCode, disabled, errorMsg;
    var _a, _b, _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _d.trys.push([0, 6, , 10]);
                return [4 /*yield*/, (0, effects_1.call)(moveInService_1.checkCommuneEligibility, action.payload.value.inseeCode)];
            case 1:
                response = _d.sent();
                if (!((response === null || response === void 0 ? void 0 : response.status) === 200)) return [3 /*break*/, 3];
                return [4 /*yield*/, (0, effects_1.put)(moveInState_1.moveInActions.getCommuneEligibilitySuccess({ responseCode: response === null || response === void 0 ? void 0 : response.status, eligibility: true, crmEnabled: (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.naiaEnabled }))];
            case 2:
                _d.sent();
                return [3 /*break*/, 5];
            case 3:
                if (!((response === null || response === void 0 ? void 0 : response.status) === 204)) return [3 /*break*/, 5];
                return [4 /*yield*/, (0, effects_1.put)(moveInState_1.moveInActions.getCommuneEligibilitySuccess({ responseCode: response === null || response === void 0 ? void 0 : response.status, eligibility: false }))];
            case 4:
                _d.sent();
                _d.label = 5;
            case 5: return [3 /*break*/, 10];
            case 6:
                e_3 = _d.sent();
                return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 7:
                language = (_d.sent()).language;
                errorCode = (_b = e_3 === null || e_3 === void 0 ? void 0 : e_3.response) === null || _b === void 0 ? void 0 : _b.status;
                disabled = (errorCode === 404 && ((_c = e_3 === null || e_3 === void 0 ? void 0 : e_3.response) === null || _c === void 0 ? void 0 : _c.data) === "NotSupported") ? true : false;
                errorMsg = (0, i18n_1.default)(language).api.auth.errors.unknownError;
                return [4 /*yield*/, (0, effects_1.put)(moveInState_1.moveInActions.getCommuneEligibilityFailure(errorMsg, errorCode, disabled))];
            case 8:
                _d.sent();
                return [4 /*yield*/, (0, effects_1.call)(reportErrorsToInstrumentation_1.default, e_3, reportErrorsToInstrumentation_1.ErrorSourceType.DATA_INTEGRITY_ERROR, (0, reportErrorsToInstrumentation_1.getCorrelationId)(0, communeEligibilityEffect.name))];
            case 9:
                _d.sent();
                return [3 /*break*/, 10];
            case 10: return [2 /*return*/];
        }
    });
}
function getEstimatedMonthlyPaiementEffect(action) {
    var data, e_4, language, errorMsg, errorCode;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 3, , 7]);
                return [4 /*yield*/, (0, effects_1.call)(moveInService_1.getEstimatedMonthlyPaiement, action.payload)];
            case 1:
                data = _b.sent();
                return [4 /*yield*/, (0, effects_1.put)(moveInState_1.moveInActions.getEstimatedMonthlyPaiementSuccess(data))];
            case 2:
                _b.sent();
                return [3 /*break*/, 7];
            case 3:
                e_4 = _b.sent();
                return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 4:
                language = (_b.sent()).language;
                errorMsg = (0, i18n_1.default)(language).api.auth.errors.unknownError;
                errorCode = (_a = e_4 === null || e_4 === void 0 ? void 0 : e_4.response) === null || _a === void 0 ? void 0 : _a.status;
                return [4 /*yield*/, (0, effects_1.put)(moveInState_1.moveInActions.getEstimatedMonthlyPaiementFailure(errorMsg, errorCode))];
            case 5:
                _b.sent();
                return [4 /*yield*/, (0, effects_1.call)(reportErrorsToInstrumentation_1.default, e_4, reportErrorsToInstrumentation_1.ErrorSourceType.DATA_INTEGRITY_ERROR, (0, reportErrorsToInstrumentation_1.getCorrelationId)(0, getEstimatedMonthlyPaiementEffect.name))];
            case 6:
                _b.sent();
                return [3 /*break*/, 7];
            case 7: return [2 /*return*/];
        }
    });
}
function fetchWaterChargeByCommuneEffect(action) {
    var data, e_5, language, errorCode, errorMsg;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 3, , 7]);
                return [4 /*yield*/, (0, effects_1.call)(moveInService_1.fetchWaterChargeByCommuneInseeCode, action.payload)];
            case 1:
                data = _b.sent();
                return [4 /*yield*/, (0, effects_1.put)(moveInState_1.moveInActions.fetchWaterChargeByCommuneSuccess(data))];
            case 2:
                _b.sent();
                return [3 /*break*/, 7];
            case 3:
                e_5 = _b.sent();
                return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 4:
                language = (_b.sent()).language;
                errorCode = (_a = e_5 === null || e_5 === void 0 ? void 0 : e_5.response) === null || _a === void 0 ? void 0 : _a.status;
                errorMsg = (0, i18n_1.default)(language).api.auth.errors.unknownError;
                return [4 /*yield*/, (0, effects_1.put)(moveInState_1.moveInActions.fetchWaterChargeByCommuneFailure(errorMsg, errorCode))];
            case 5:
                _b.sent();
                return [4 /*yield*/, (0, effects_1.call)(reportErrorsToInstrumentation_1.default, e_5, reportErrorsToInstrumentation_1.ErrorSourceType.DATA_INTEGRITY_ERROR, (0, reportErrorsToInstrumentation_1.getCorrelationId)(0, fetchWaterChargeByCommuneEffect.name))];
            case 6:
                _b.sent();
                return [3 /*break*/, 7];
            case 7: return [2 /*return*/];
        }
    });
}
function fetchMetersByAddressEffect(action) {
    var data, e_6, language, errorCode, errorMsg;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 3, , 7]);
                return [4 /*yield*/, (0, effects_1.call)(moveInService_1.fetchMetersByAddress, action.payload[0], action.payload[1], action.payload[2])];
            case 1:
                data = _b.sent();
                return [4 /*yield*/, (0, effects_1.put)(moveInState_1.moveInActions.fetchMetersByAddressSuccess(data))];
            case 2:
                _b.sent();
                return [3 /*break*/, 7];
            case 3:
                e_6 = _b.sent();
                return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 4:
                language = (_b.sent()).language;
                errorCode = (_a = e_6 === null || e_6 === void 0 ? void 0 : e_6.response) === null || _a === void 0 ? void 0 : _a.status;
                errorMsg = (0, i18n_1.default)(language).api.auth.errors.unknownError;
                return [4 /*yield*/, (0, effects_1.put)(moveInState_1.moveInActions.fetchMetersByAddressFailure(errorMsg, errorCode))];
            case 5:
                _b.sent();
                return [4 /*yield*/, (0, effects_1.call)(reportErrorsToInstrumentation_1.default, e_6, reportErrorsToInstrumentation_1.ErrorSourceType.DATA_INTEGRITY_ERROR, (0, reportErrorsToInstrumentation_1.getCorrelationId)(0, fetchMetersByAddressEffect.name))];
            case 6:
                _b.sent();
                return [3 /*break*/, 7];
            case 7: return [2 /*return*/];
        }
    });
}
function getDeliveryPointAddressEffect(action) {
    var data, address, e_7, language, errorMsg, errorCode;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 3, , 7]);
                return [4 /*yield*/, (0, effects_1.call)(moveInService_1.getDeliveryPointAddress, action.payload)];
            case 1:
                data = _c.sent();
                address = {
                    streetAddress: data.lane,
                    lieuDit: data.lane,
                    addressComplement: data.addressComplement,
                    zipCode: data.zipCode,
                    commune: data.commune,
                    inseeCode: data.inseeCode,
                    country: data.countryCode,
                    streetNumber: data.number,
                    building: data.building,
                    stairs: data.stairs,
                    floor: data.floor,
                    door: data.door
                };
                return [4 /*yield*/, (0, effects_1.put)(moveInState_1.moveInActions.getDeliveryPointAddressSuccess(address))];
            case 2:
                _c.sent();
                return [3 /*break*/, 7];
            case 3:
                e_7 = _c.sent();
                return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 4:
                language = (_c.sent()).language;
                errorMsg = (0, i18n_1.default)(language).api.auth.errors.unknownError;
                if (((_a = e_7 === null || e_7 === void 0 ? void 0 : e_7.response) === null || _a === void 0 ? void 0 : _a.status) === 404)
                    errorMsg = (0, i18n_1.default)(language).moveIn.meterInfos.unknownMeterId;
                errorCode = (_b = e_7 === null || e_7 === void 0 ? void 0 : e_7.response) === null || _b === void 0 ? void 0 : _b.status;
                return [4 /*yield*/, (0, effects_1.put)(moveInState_1.moveInActions.getDeliveryPointAddressFailure(errorMsg, errorCode))];
            case 5:
                _c.sent();
                return [4 /*yield*/, (0, effects_1.call)(reportErrorsToInstrumentation_1.default, e_7, reportErrorsToInstrumentation_1.ErrorSourceType.DATA_INTEGRITY_ERROR, (0, reportErrorsToInstrumentation_1.getCorrelationId)(0, getDeliveryPointAddressEffect.name))];
            case 6:
                _c.sent();
                return [3 /*break*/, 7];
            case 7: return [2 /*return*/];
        }
    });
}
function anyMeterBySerialNumberEffect(action) {
    var e_8, language, errorMsg, errorCode;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 3, , 7]);
                return [4 /*yield*/, (0, effects_1.call)(moveInService_1.anyMeterBySerialNumber, action.payload[0], action.payload[1])];
            case 1:
                _c.sent();
                return [4 /*yield*/, (0, effects_1.put)(moveInState_1.moveInActions.anyMeterBySerialNumberSuccess())];
            case 2:
                _c.sent();
                return [3 /*break*/, 7];
            case 3:
                e_8 = _c.sent();
                return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 4:
                language = (_c.sent()).language;
                errorMsg = (0, i18n_1.default)(language).api.auth.errors.unknownError;
                if (((_a = e_8 === null || e_8 === void 0 ? void 0 : e_8.response) === null || _a === void 0 ? void 0 : _a.status) === 404)
                    errorMsg = (0, i18n_1.default)(language).moveIn.meterInfos.unknownMeterId;
                errorCode = (_b = e_8 === null || e_8 === void 0 ? void 0 : e_8.response) === null || _b === void 0 ? void 0 : _b.status;
                return [4 /*yield*/, (0, effects_1.put)(moveInState_1.moveInActions.anyMeterBySerialNumberFailure(errorMsg, errorCode))];
            case 5:
                _c.sent();
                return [4 /*yield*/, (0, effects_1.call)(reportErrorsToInstrumentation_1.default, e_8, reportErrorsToInstrumentation_1.ErrorSourceType.DATA_INTEGRITY_ERROR, (0, reportErrorsToInstrumentation_1.getCorrelationId)(0, anyMeterBySerialNumberEffect.name))];
            case 6:
                _c.sent();
                return [3 /*break*/, 7];
            case 7: return [2 /*return*/];
        }
    });
}
function anyMeterByRegistrationNumberEffect(action) {
    var e_9, language, errorMsg, errorCode;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 3, , 7]);
                return [4 /*yield*/, (0, effects_1.call)(moveInService_1.anyMeterByRegistrationNumber, action.payload)];
            case 1:
                _c.sent();
                return [4 /*yield*/, (0, effects_1.put)(moveInState_1.moveInActions.anyMeterByRegistrationNumberSuccess())];
            case 2:
                _c.sent();
                return [3 /*break*/, 7];
            case 3:
                e_9 = _c.sent();
                return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 4:
                language = (_c.sent()).language;
                errorMsg = (0, i18n_1.default)(language).api.auth.errors.unknownError;
                if (((_a = e_9 === null || e_9 === void 0 ? void 0 : e_9.response) === null || _a === void 0 ? void 0 : _a.status) === 404)
                    errorMsg = (0, i18n_1.default)(language).moveIn.meterInfos.unknownMeterId;
                errorCode = (_b = e_9 === null || e_9 === void 0 ? void 0 : e_9.response) === null || _b === void 0 ? void 0 : _b.status;
                return [4 /*yield*/, (0, effects_1.put)(moveInState_1.moveInActions.anyMeterByRegistrationNumberFailure(errorMsg, errorCode))];
            case 5:
                _c.sent();
                return [4 /*yield*/, (0, effects_1.call)(reportErrorsToInstrumentation_1.default, e_9, reportErrorsToInstrumentation_1.ErrorSourceType.DATA_INTEGRITY_ERROR, (0, reportErrorsToInstrumentation_1.getCorrelationId)(0, anyMeterByRegistrationNumberEffect.name))];
            case 6:
                _c.sent();
                return [3 /*break*/, 7];
            case 7: return [2 /*return*/];
        }
    });
}
function createMovingInRequestEffect(action) {
    var movingInRequestId, e_10, language, errorMsg, errorCode;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 3, , 7]);
                return [4 /*yield*/, (0, effects_1.call)(moveInService_1.createMovingInRequest, action.payload.movingInRequest, action.payload.captchaToken)];
            case 1:
                movingInRequestId = _b.sent();
                return [4 /*yield*/, (0, effects_1.put)(moveInState_1.moveInActions.CreateMovingInRequestSuccess(movingInRequestId))];
            case 2:
                _b.sent();
                return [3 /*break*/, 7];
            case 3:
                e_10 = _b.sent();
                return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 4:
                language = (_b.sent()).language;
                errorMsg = (0, i18n_1.default)(language).api.auth.errors.unknownError;
                errorCode = (_a = e_10 === null || e_10 === void 0 ? void 0 : e_10.response) === null || _a === void 0 ? void 0 : _a.status;
                return [4 /*yield*/, (0, effects_1.put)(moveInState_1.moveInActions.CreateMovingInRequestFailure(errorMsg, errorCode))];
            case 5:
                _b.sent();
                return [4 /*yield*/, (0, effects_1.call)(reportErrorsToInstrumentation_1.default, e_10, reportErrorsToInstrumentation_1.ErrorSourceType.DATA_INTEGRITY_ERROR, (0, reportErrorsToInstrumentation_1.getCorrelationId)(0, createMovingInRequestEffect.name))];
            case 6:
                _b.sent();
                return [3 /*break*/, 7];
            case 7: return [2 /*return*/];
        }
    });
}
function trackMovingInRequestEffect(action) {
    var e_11, language, errorMsg, errorCode;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 3, , 7]);
                return [4 /*yield*/, (0, effects_1.call)(moveInService_1.trackMovingInRequest, action.payload)];
            case 1:
                _b.sent();
                return [4 /*yield*/, (0, effects_1.put)(moveInState_1.moveInActions.TrackMovingInRequestSuccess())];
            case 2:
                _b.sent();
                return [3 /*break*/, 7];
            case 3:
                e_11 = _b.sent();
                return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 4:
                language = (_b.sent()).language;
                errorMsg = (0, i18n_1.default)(language).api.auth.errors.unknownError;
                errorCode = (_a = e_11 === null || e_11 === void 0 ? void 0 : e_11.response) === null || _a === void 0 ? void 0 : _a.status;
                return [4 /*yield*/, (0, effects_1.put)(moveInState_1.moveInActions.TrackMovingInRequestFailure(errorMsg, errorCode))];
            case 5:
                _b.sent();
                return [4 /*yield*/, (0, effects_1.call)(reportErrorsToInstrumentation_1.default, e_11, reportErrorsToInstrumentation_1.ErrorSourceType.DATA_INTEGRITY_ERROR, (0, reportErrorsToInstrumentation_1.getCorrelationId)(0, trackMovingInRequestEffect.name))];
            case 6:
                _b.sent();
                return [3 /*break*/, 7];
            case 7: return [2 /*return*/];
        }
    });
}
function getCountrySuggestionEffect(action) {
    var data, e_12, language, errorMsg, errorCode;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 6, , 10]);
                return [4 /*yield*/, (0, effects_1.call)(moveInService_1.getCountriesSuggestions)];
            case 1:
                data = _b.sent();
                if (!data.length) return [3 /*break*/, 3];
                return [4 /*yield*/, (0, effects_1.put)(moveInState_1.moveInActions.getCountrySuggestionSuccess(data))];
            case 2:
                _b.sent();
                return [3 /*break*/, 5];
            case 3: return [4 /*yield*/, (0, effects_1.put)(moveInState_1.moveInActions.getCountrySuggestionSuccess([]))];
            case 4:
                _b.sent();
                _b.label = 5;
            case 5: return [3 /*break*/, 10];
            case 6:
                e_12 = _b.sent();
                return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 7:
                language = (_b.sent()).language;
                errorMsg = (0, i18n_1.default)(language).api.auth.errors.unknownError;
                errorCode = (_a = e_12 === null || e_12 === void 0 ? void 0 : e_12.response) === null || _a === void 0 ? void 0 : _a.status;
                return [4 /*yield*/, (0, effects_1.put)(moveInState_1.moveInActions.getCountrySuggestionFailure(errorMsg, errorCode))];
            case 8:
                _b.sent();
                return [4 /*yield*/, (0, effects_1.call)(reportErrorsToInstrumentation_1.default, e_12, reportErrorsToInstrumentation_1.ErrorSourceType.DATA_INTEGRITY_ERROR, (0, reportErrorsToInstrumentation_1.getCorrelationId)(0, getCountrySuggestionEffect.name))];
            case 9:
                _b.sent();
                return [3 /*break*/, 10];
            case 10: return [2 /*return*/];
        }
    });
}
function getCitySuggestionEffect(action) {
    var data, e_13, language, errorMsg, errorCode;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 6, , 10]);
                return [4 /*yield*/, (0, effects_1.call)(moveInService_1.getCitiesiesSuggestions, action.payload)];
            case 1:
                data = _b.sent();
                if (!data.length) return [3 /*break*/, 3];
                return [4 /*yield*/, (0, effects_1.put)(moveInState_1.moveInActions.getCitySuggestionSuccess(handleCities(data)))];
            case 2:
                _b.sent();
                return [3 /*break*/, 5];
            case 3: return [4 /*yield*/, (0, effects_1.put)(moveInState_1.moveInActions.getCitySuggestionSuccess([]))];
            case 4:
                _b.sent();
                _b.label = 5;
            case 5: return [3 /*break*/, 10];
            case 6:
                e_13 = _b.sent();
                return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 7:
                language = (_b.sent()).language;
                errorMsg = (0, i18n_1.default)(language).api.auth.errors.unknownError;
                errorCode = (_a = e_13 === null || e_13 === void 0 ? void 0 : e_13.response) === null || _a === void 0 ? void 0 : _a.status;
                return [4 /*yield*/, (0, effects_1.put)(moveInState_1.moveInActions.getCitySuggestionFailure(errorMsg, errorCode))];
            case 8:
                _b.sent();
                return [4 /*yield*/, (0, effects_1.call)(reportErrorsToInstrumentation_1.default, e_13, reportErrorsToInstrumentation_1.ErrorSourceType.DATA_INTEGRITY_ERROR, (0, reportErrorsToInstrumentation_1.getCorrelationId)(0, getCitySuggestionEffect.name))];
            case 9:
                _b.sent();
                return [3 /*break*/, 10];
            case 10: return [2 /*return*/];
        }
    });
}
function moveInEffects() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.takeLatest)(moveInState_1.moveInActions.getCommuneSuggestion.type, getCommuneSuggestionEffect)];
            case 1:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(moveInState_1.moveInActions.getEstimatedMonthlyPaiement.type, getEstimatedMonthlyPaiementEffect)];
            case 2:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(moveInState_1.moveInActions.fetchWaterChargeByCommune.type, fetchWaterChargeByCommuneEffect)];
            case 3:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(moveInState_1.moveInActions.fetchMetersByAddress.type, fetchMetersByAddressEffect)];
            case 4:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(moveInState_1.moveInActions.anyMeterBySerialNumber.type, anyMeterBySerialNumberEffect)];
            case 5:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(moveInState_1.moveInActions.anyMeterByRegistrationNumber.type, anyMeterByRegistrationNumberEffect)];
            case 6:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(moveInState_1.moveInActions.getDeliveryPointAddress.type, getDeliveryPointAddressEffect)];
            case 7:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(moveInState_1.moveInActions.subscribe.type, subscribeEffect)];
            case 8:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(moveInState_1.moveInActions.getCommuneEligibility.type, communeEligibilityEffect)];
            case 9:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(moveInState_1.moveInActions.CreateMovingInRequest.type, createMovingInRequestEffect)];
            case 10:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(moveInState_1.moveInActions.TrackMovingInRequest.type, trackMovingInRequestEffect)];
            case 11:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(moveInState_1.moveInActions.getCountrySuggestion.type, getCountrySuggestionEffect)];
            case 12:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(moveInState_1.moveInActions.getCitySuggestion.type, getCitySuggestionEffect)];
            case 13:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
exports.default = moveInEffects;
